import React from 'react'

export default class Contact extends React.Component {

  componentWillMount() {
    if (this.props.content.selectedPage !== 'not-found') {
      this.props.changePage('not-found', 'side')
    }
  }

  render() {
    return (
      <h1>404</h1>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/NotFound.js